module.exports = __webpack_public_path__ + "static/foto1-f7566e4d55449f5a103d118617c7cedb.jpg";